var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "general-summay-containter",
      attrs: { id: "general-summay-content" },
    },
    [
      _c(
        "tender-head",
        {
          ref: "tenderEditHead",
          attrs: { tenderGeneral: _vm.currentTender.general },
        },
        [
          _vm.isPicView && _vm.isIssued ? _c("start-addendum") : _vm._e(),
          _vm._v(" "),
          _vm.allowStartAnalysis
            ? _c(
                "button",
                {
                  staticClass: "btn btn--orange nav-btns",
                  on: { click: _vm.startAnalysis },
                },
                [_vm._v(_vm._s(_vm.$t("action.startAnalysis")))]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "general-summay-accordion-container" } },
        [
          _c(
            "Collapse",
            {
              staticClass: "tender-summary-collapse",
              attrs: { title: _vm.$t("summary.name"), withBorder: false },
            },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  { attrs: { id: "router-view-content" } },
                  [
                    _c("HKLSelect", {
                      staticStyle: { width: "330px" },
                      attrs: {
                        value: _vm.componentName
                          ? _vm.componentName.target
                          : undefined,
                        options: _vm.componentHklOptions,
                        showSearch: false,
                        placeholder: "",
                      },
                      on: { change: _vm.onComponentChange },
                    }),
                    _vm._v(" "),
                    _c("router-view", {
                      staticClass: "router-view-content-detail",
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentTender.general.id === _vm.tenderId
        ? _c("detail-summary", { attrs: { tenderId: _vm.tenderId } })
        : _vm._e(),
      _vm._v(" "),
      _c("TenderRepresentative", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTenderRep,
            expression: "showTenderRep",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }